import script from "./ClubSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubSetup.vue?vue&type=script&setup=true&lang=js"

import "./ClubSetup.vue?vue&type=style&index=0&id=7820d6ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7820d6ee"]])

export default __exports__